import React from "react";
import _ from "lodash";
import { NetworkAPI } from "apis";

import ModalWrapper from "components/common/ModalWrapper";
import ModalFooter from "components/common/ModalFooter";
import TextAreaWithJsonCheck from "components/common/TextAreaWithJsonCheck";

import FirstLookSettingTable from "./FirstLookSettingTable";

import { TYPE } from "./Constants";

import { MESSAGE } from "constants/Message";
import {
  validateFirstLook,
  validateRuleCustom,
  cleanupRule,
} from "helpers/CustomUprFirstLookUtils";

import { buttonModalConfirmClass } from "helpers/StyleClass.js";

class EditCustomFirstLookDataModal extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      inputValue: JSON.stringify(props.currentData, null, 4),
      configData: _.cloneDeep(props.currentData),

      selectedType: TYPE.DISPLAY,
      popupId: "",
      msg: [],
      isValidating: false,
    };

    this.handleInputChanged = this.handleInputChanged.bind(this);
    this.handleValidateData = this.handleValidateData.bind(this);
    this.handleDataChanged = this.handleDataChanged.bind(this);
  }

  handleInputChanged(value) {
    this.setState({ inputValue: value, msg: [] });

    try {
      const json = JSON.parse(value);
      this.setState({ configData: json });
    } catch (error) {}
  }

  async handleValidateData() {
    const { inputValue } = this.state;
    this.setState({ isValidating: true });

    try {
      const json = JSON.parse(inputValue);
      const newConfig = _.mapValues(json, (list) => {
        return _.map(list, (rule) => cleanupRule(rule));
      });
      const typeList = _.keys(newConfig);
      const inValidType = _.filter(
        typeList,
        (type) => !_.values(TYPE).includes(type)
      );

      if (inValidType.length > 0) {
        throw new Error(`Invalid type found: ${inValidType.join(", ")}`);
      }

      const errMsgList = [];
      const warnIdList = [];
      _.keys(newConfig).forEach((type) => {
        newConfig[type].forEach((rule, idx) => {
          const errMsg = validateFirstLook(rule, false, newConfig[type]);
          const isPassWarn = validateRuleCustom(rule);

          if (errMsg !== "")
            errMsgList.push(
              `${
                rule.id ? `Rule [${type}:${rule.id}]` : `Index [${type}:${idx}]`
              }: ${errMsg}`
            );
          if (!isPassWarn && rule.enabled !== false) warnIdList.push(rule.id);
        });
      });

      const newWarnMsg = `The Customs section is empty [RuleID]: ${warnIdList.join(
        ", "
      )}`;

      // Frontend validation errors
      if (errMsgList.length > 0) {
        const unionMsg = _.union(errMsgList);
        throw new Error(unionMsg.join("; "));
      }

      // API validation errors
      const { isValid, reason } =
        await NetworkAPI.validateCustomFirstLookSetting({
          setting: newConfig,
        });
      if (!isValid) {
        throw new Error(reason || "Validation failed!");
      }

      // Warnings
      if (warnIdList.length > 0) {
        this.setState({
          msg: [newWarnMsg, MESSAGE.WARNING],
        });
      } else {
        this.setState({
          msg: ["Validation passed!", ""],
        });
      }
    } catch (error) {
      console.log(error);
      this.setState({
        msg: [error.toString(), MESSAGE.ERROR],
      });
    }

    this.setState({ isValidating: false });
  }

  handleDataChanged() {
    const { inputValue } = this.state;
    const { handleDataChanged } = this.props;
    if (handleDataChanged) {
      const json = JSON.parse(inputValue);
      const newConfig = _.mapValues(json, (list) => {
        return _.map(list, (rule) => cleanupRule(rule));
      });
      handleDataChanged(newConfig);
    }
  }

  render() {
    const {
      handleClose,

      networkId,
      networkInfo,
      units,
      virtualPlacements,
      placements,
      firstLookCurrency,
    } = this.props;

    const { inputValue, configData, popupId, selectedType, msg, isValidating } =
      this.state;

    return (
      <ModalWrapper
        isOpen={true}
        showCloseFooter={false}
        width="65%"
        title="Edit Custom First Look JSON"
        customOverlayStyle={{ zIndex: 100 }}
      >
        <div className="mb-6 flex gap-4" style={{ height: "520px" }}>
          <div className="w-1/3 overflow-y-auto">
            <TextAreaWithJsonCheck
              rows={19}
              iconOnly={true}
              inputValue={inputValue}
              handleInputChanged={this.handleInputChanged}
            ></TextAreaWithJsonCheck>
          </div>
          <div className="flex w-2/3 flex-col">
            <div className="text-gray-600">Preview</div>
            <div className="mt-2 flex flex-wrap items-center text-sm">
              {_.values(TYPE).map((type) => {
                return (
                  <button
                    key={type}
                    type="button"
                    className={`border rounded mb-1 mr-1 border-gray-200 ${
                      selectedType === type ? "bg-blue-200" : "bg-white"
                    }  px-2 py-1 text-gray-800 hover:border-blue-400`}
                    onClick={() => {
                      this.setState({
                        selectedType: type,
                        popupId: "",
                      });
                    }}
                  >
                    {type} ({(configData[type] || []).length})
                  </button>
                );
              })}
            </div>
            <div
              className="rounded flex-1 overflow-y-auto bg-gray-200 p-4"
              style={{ paddingBottom: "280px" }}
            >
              <FirstLookSettingTable
                popupId={popupId}
                isSearch={false}
                networkId={networkId}
                items={configData[selectedType] || []}
                networkInfo={networkInfo}
                currency={firstLookCurrency}
                units={units}
                virtualPlacements={virtualPlacements}
                placements={placements}
                customRules={configData[selectedType] || []}
                handlePopupIdChange={(id) => this.setState({ popupId: id })}
                readOnly={true}
                place="left center"
              ></FirstLookSettingTable>
            </div>
          </div>
        </div>

        <ModalFooter
          msg={msg}
          redo={true}
          isLoading={isValidating}
          onCancel={handleClose}
          onConfirm={this.handleDataChanged}
          confirmText="Replace"
          disableConfirm={
            msg.length === 0 || (msg.length > 0 && msg[1] === MESSAGE.ERROR)
          }
        >
          <button
            type="button"
            className={buttonModalConfirmClass}
            onClick={this.handleValidateData}
          >
            Validate
          </button>
        </ModalFooter>
      </ModalWrapper>
    );
  }
}

export default EditCustomFirstLookDataModal;
